/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EventTypes {
    Product_Creations_Created = 110101,
    Product_MasterDataChanges_Description = 110201,
    Product_MasterDataChanges_Description2 = 110202,
    Product_MasterDataChanges_Type = 110203,
    Product_MasterDataChanges_Summary = 110204,
    Product_Deletions_Deleted = 110301,
    Product_Type_Created = 110401,
    Product_Pictures_Added = 110501,
    Product_Pictures_Sort_Order_Changed = 110502,
    Product_Pictures_Primary_Changed = 110503,
    Product_Removed = 110504,
    Product_MasterDataChanges_StatusCode = 110505,
    Product_AssetStore_Added = 110601,
    Product_AssetStore_Changed = 110602,
    Product_AssetStore_Removed = 110603,
    Product_Price_Added = 110701,
    Product_Price_Changed = 110702,
    Product_Price_Removed = 110703,
    Customer_Creations_Created = 120101,
    Customer_MasterDataChanges_Name = 120205,
    Customer_MasterDataChanges_Name2 = 120206,
    Customer_MasterDataChanges_EmailsInvoice = 120216,
    Customer_MasterDataChanges_VATNumber = 120225,
    Customer_MasterDataChanges_VatCountry = 120226,
    Customer_MasterDataChanges_VATExemptionTrue = 120227,
    Customer_MasterDataChanges_VATExemptionFalse = 120228,
    Customer_MasterDataChanges_BlockedComment = 120234,
    Customer_MasterDataChanges_CustomerPaymentTerm = 120251,
    Customer_MasterDataChanges_BlockedPublicAccessTrue = 120300,
    Customer_MasterDataChanges_BlockedPublicAccessFalse = 120301,
    Customer_MasterDataChanges_ResponsibleEmployee = 120302,
    Customer_MasterDataChanges_HomePage = 120303,
    Customer_MasterDataChanges_Currency = 120304,
    Customer_Deletions_Deleted = 120301,
    Customer_Communication_MessageSent = 120401,
    Customer_DeliveryAddresses_ChangedRoundingMethodCheckOut = 120591,
    Customer_ContactPersons_Created = 120601,
    Customer_ContactPersons_Email_Updated = 120602,
    Customer_ContactPersons_Name_Updated = 120603,
    Customer_ContactPersons_Language_Updated = 120604,
    Customer_ContactPersons_Activated = 120605,
    Customer_ContactPersons_Deactivated = 120606,
    Customer_ContactPersons_Deleted = 120607,
    Customer_ContactPersons_FirstName = 120608,
    Customer_ContactPersons_MiddleName = 120609,
    Customer_ContactPersons_LastName = 120610,
    Customer_ContactPersons_FullName = 120611,
    Customer_ContactPersons_IsAdmin_Activated = 120612,
    Customer_ContactPersons_IsAdmin_Deactivated = 120613,
    Customer_ContactPersons_LanguageId = 120614,
    Customer_ContactPersons_UnitId = 120615,
    Customer_ContactPersons_DateFormatId = 120616,
    Customer_ContactPersons_ContactPersonPictureId = 120617,
    Customer_ContactPersons_MobilePhoneCountryId = 120618,
    Customer_ContactPersons_MobilePhoneNo = 120619,
    Customer_ContactPersons_Permission_Added = 120620,
    Customer_ContactPersons_Permission_Removed = 120621,
    Customer_SalesPersons_Added = 120701,
    Customer_SalesPersons_ChangedRole = 120702,
    Customer_SalesPersons_ChangedComment = 120703,
    Customer_SalesPersons_Removed = 120704,
    Employee_Creations_Created = 140101,
    Employee_MasterDataChanges_FirstName = 140202,
    Employee_MasterDataChanges_LastName = 140203,
    Employee_MasterDataChanges_Email = 140204,
    Employee_MasterDataChanges_ShortName = 140205,
    Employee_MasterDataChanges_Department = 140206,
    Employee_MasterDataChanges_LocalPhoneNo = 140207,
    Employee_MasterDataChanges_SIPUserName = 140208,
    Employee_MasterDataChanges_SIPPassword = 140209,
    Employee_MasterDataChanges_TerminatedTrue = 140210,
    Employee_MasterDataChanges_TerminatedFalse = 140211,
    Employee_MasterDataChanges_PhoneNo = 140212,
    Employee_MasterDataChanges_MobilePhoneNo = 140213,
    Employee_MasterDataChanges_Position = 140214,
    Employee_MasterDataChanges_TerminatedOn = 140215,
    Employee_MasterDataChanges_PictureUpdated = 140216,
    Employee_Communication_EmailSent = 140301,
    Employee_Communication_EmailReceived = 140302,
    Employee_Communication_EmailDeleted = 140303,
    Document_Type_Creations_Created = 150101,
    Document_Type_MasterDataChanges_DescriptionUK = 150201,
    Document_Type_MasterDataChanges_DescriptionDK = 150202,
    Document_Type_MasterDataChanges_ShowInSummary_Activated = 150203,
    Document_Type_MasterDataChanges_ShowInSummary_Deactivated = 150204,
    Document_Type_MasterDataChanges_SortOrder = 150205,
    Document_Type_Deletions_Deleted = 150301,
    System_Settings_MasterDataChanges_Value = 160101,
    System_Settings_MasterDataChanges_Value_Translation = 160102,
    System_Settings_MasterDataChanges_Description = 160103,
    System_Settings_MasterDataChanges_Is_Editable_Activated = 160104,
    System_Settings_MasterDataChanges_Is_Editable_Deactivated = 160105,
    Configurator_List_Creations_Created = 170101,
    Configurator_List_MasterDataChanges_Description = 170201,
    Configurator_List_MasterDataChanges_IsActive = 170202,
    Configurator_List_MasterDataChanges_BCListID = 170203,
    Configurator_ListItem_MasterDataChanges_Value = 170204,
    Configurator_ListItem_MasterDataChanges_BCListID = 170205,
    Configurator_ListItem_MasterDataChanges_BCListItemID = 170206,
    Configurator_List_MasterDataChanges_BCSystemId = 170207,
    Configurator_ListItem_MasterDataChanges_BCSystemId = 170208,
    Configurator_List_MasterDataChanges_IsDeactive = 170209,
    Configurator_List_Deletions_Soft_Deleted = 170301,
    Configurator_List_Deletions_Hard_Deleted = 170302,
    Configurator_List_Item_Creations_Created = 180101,
    Configurator_List_Item_MasterDataChanges_Value = 180201,
    Configurator_List_Item_MasterDataChanges_SortOrder = 180202,
    Configurator_List_Item_Deletions_Soft_Deleted = 180301,
    Configurator_List_Item_Deletions_Hard_Deleted = 180302,
    Configurator_Attribute_Creations_Created = 190101,
    Configurator_Attribute_MasterDataChanges_Description = 190201,
    Configurator_Attribute_MasterDataChanges_AttributeEntityKind = 190202,
    Configurator_Attribute_MasterDataChanges_AttributeEntityFilterId = 190203,
    Configurator_Attribute_MasterDataChanges_AttributeType = 190204,
    Configurator_Attribute_MasterDataChanges_IsList_On = 190205,
    Configurator_Attribute_MasterDataChanges_IsList_Off = 190206,
    Configurator_Attribute_MasterDataChanges_ReferenceType = 190207,
    Configurator_Attribute_MasterDataChanges_ReferenceFilterId = 190208,
    Configurator_Attribute_MasterDataChanges_ListId = 190209,
    Configurator_Attribute_MasterDataChanges_SortOrder = 190210,
    Configurator_Attribute_MasterDataChanges_Required_On = 190211,
    Configurator_Attribute_MasterDataChanges_Required_Off = 190212,
    Configurator_Attribute_MasterDataChanges_ColorType = 190213,
    Configurator_Attribute_Deletions_Soft_Deleted = 190301,
    Configurator_Attribute_Deletions_Hard_Deleted = 190302,
    Configurator_Rule_Created = 200101,
    Configurator_Rule_Condition_Created = 200102,
    Configurator_Rule_Condition_Value_Created = 200103,
    Configurator_Rule_Restriction_Created = 200104,
    Configurator_Rule_Restriction_Value_Created = 200105,
    Configurator_Rule_MasterDataChanges_Description = 200201,
    Configurator_Rule_MasterDataChanges_SourceAttributeId = 200202,
    Configurator_Rule_MasterDataChanges_TargetAttributeId = 200203,
    Configurator_Rule_MasterDataChanges_Rule_Condition_Description = 200204,
    Configurator_Rule_MasterDataChanges_Rule_Condition_Value = 200205,
    Configurator_Rule_MasterDataChanges_Rule_Condition_Type = 200206,
    Configurator_Rule_MasterDataChanges_Rule_Condition_Usage = 200207,
    Configurator_Rule_MasterDataChanges_Rule_Condition_Value_Value = 200208,
    Configurator_Rule_MasterDataChanges_Rule_Restriction_Description = 200209,
    Configurator_Rule_MasterDataChanges_Rule_Restriction_Type = 200210,
    Configurator_Rule_MasterDataChanges_Rule_Restriction_Value_Value = 200211,
    Configurator_Rule_MasterDataChanges_IsBidirectional_On = 200212,
    Configurator_Rule_MasterDataChanges_IsBidirectional_Off = 200213,
    Configurator_Rule_Deleted = 200301,
    Configurator_Rule_Condition_Deleted = 200302,
    Configurator_Rule_Condition_Value_Deleted = 200303,
    Configurator_Rule_Restriction_Deleted = 200304,
    Configurator_Rule_Restriction_Value_Deleted = 200305,
    SystemProductConfiguration_MasterDataChanges_ProjectId = 210201,
    SystemProductConfiguration_MasterDataChanges_SystemPackageId = 210202,
    SystemProductConfiguration_MasterDataChanges_Description = 210203,
    System_IntegrationTest_FromDekoXtoPublicApi = 999901,
}
